import { apiClient } from '@/common/lib/api-client';

/**
 * Retrieve public digital business card details
 * GET /v1/companies/public/business-cards/{short_id}/
 */
export async function getPublicBusinessCardDetails(shortId) {
  const { data } = await apiClient.get(
    `/v1/companies/public/business-cards/${shortId}/`,
  );
  return data;
}
